@import '../../style/index';

:host {
  display: block;

  .rcm-language-switcher {
    &--hide {
      display: none;
    }
  }

  .modal {
    box-sizing: border-box;
    padding: rem-calc(20px);
    width: rem-calc(335px);

    @include medium-up {
      width: rem-calc(400px);
      padding: var(--spacings-l);
    }

    &__icon {
      display: flex;
      justify-content: end;
      padding: rem-calc(12px);
      margin-bottom: var(--spacings-l);

      @include medium-up() {
        margin-bottom: var(--spacings-xl);
      }

      rcm-icon {
        cursor: pointer;
      }
    }

    &__textarea {
      display: flex;
      flex-direction: column;
      gap: var(--spacings-s);
      text-align: center;
      margin-bottom: var(--spacings-l);

      @include medium-up() {
        margin-bottom: var(--spacings-xl);
      }

      &__headline {
        font-size: rem-calc(20px);
        line-height: rem-calc(28px);
        font-family: $font-family-semibold;
        color: var(--colors-dark-base);
      }

      &__text {
        font-size: rem-calc(16px);
        line-height: rem-calc(24px);
        color: var(--colors-grey-dark);
      }
    }

    &__buttons {
      display: flex;
      flex-direction: column;
      gap: var(--spacings-s);

      .rcm-button {
        width: 100%;
      }
    }
  }
}
